<template>
    <div class="time-remaining-label" :class="{ [color]: true }" >
        <fa-icon class="timeout-icon" icon="hourglass-half" />
        <span class="time-remaining">
            {{ formatTimeRemaining(timeRemainingMs) }}
        </span>
    </div>
</template>

<script>

import {
    formatTimeRemaining,
} from '../TimeoutBlitz/TimeoutBlitz-helpers';

export default {
    props: [
        'color',
        'timeRemainingMs',
    ],
    name: 'TimeRemainingLabel',
    data() {
        return {
            showMenu: false,
            formatTimeRemaining,
        };
    },
    computed: {},
    methods: {},
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .time-remaining-label {
        border: 1px solid silver;
        border-radius: 4px;
        display: inline-flex;
        font-size: .9em;
        padding: 3px 8px;
        position: relative;
        white-space: nowrap;

        > *{
            align-self: center;
        }

        &.white {
            background: white;

            .link {
                color: $dark-blue;
            }
        }

        &.black {
            background: $dark-gray;
            color: $silver;
            border-color: $dark-gray;

            .royal-coin {
                border: 1px solid $silver;
                border-radius: 50%;
            }

            .link {
                color: $silver;
            }
        }

        .time-remaining {
            margin-left: 2px;
            min-width: 33px;
        }
    }
</style>
